import React from 'react';
export var Lightbulb = function Lightbulb(props) {
  var beamColor = props.secondaryColor || '#DD9010';
  return /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53207 4.20639C13.5123 4.15236 16.7615 7.32964 16.7615 11.2729C16.7615 13.187 15.9896 14.9198 14.753 16.1874C13.9408 17.0232 13.4646 18.1046 13.4236 19.2467L13.4233 19.253L13.4229 19.2593C13.4013 19.6024 13.1112 19.8612 12.7797 19.8612H6.48979C6.14301 19.8612 5.86761 19.5928 5.84658 19.2593L5.84612 19.252L5.84588 19.2446C5.81012 18.1104 5.3294 17.0244 4.51739 16.194C3.28582 14.9374 2.52026 13.2165 2.50803 11.3268C2.47783 7.45491 5.63452 4.26045 9.53193 4.20639L9.53207 4.20639ZM9.54479 5.14325C6.15512 5.19034 3.41867 7.97042 3.44495 11.3197L3.44496 11.3204C3.45547 12.9569 4.11781 14.4478 5.1867 15.5383L5.18707 15.5387C6.08611 16.458 6.65451 17.6512 6.76515 18.9242H12.5053C12.6195 17.6483 13.1821 16.4594 14.0815 15.5341L14.0821 15.5335C15.1573 14.4314 15.8246 12.9299 15.8246 11.2729C15.8246 7.86003 13.0106 5.09628 9.54493 5.14325",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.87061 6.97331C8.87061 6.71458 9.08035 6.50484 9.33908 6.50484C12.0473 6.50484 14.2428 8.70032 14.2428 11.4086C14.2428 11.6673 14.0331 11.8771 13.7743 11.8771C13.5156 11.8771 13.3059 11.6673 13.3059 11.4086C13.3059 9.21778 11.5299 7.44179 9.33908 7.44179C9.08035 7.44179 8.87061 7.23204 8.87061 6.97331Z",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.9882 1.2547C4.19518 1.09946 4.48882 1.14141 4.64406 1.3484L5.69539 2.75016C5.85062 2.95715 5.80868 3.25079 5.60169 3.40603C5.39471 3.56126 5.10106 3.51932 4.94583 3.31233L3.8945 1.91057C3.73926 1.70358 3.78121 1.40994 3.9882 1.2547Z",
    fill: beamColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4019 1.2547C15.195 1.09946 14.9013 1.14141 14.7461 1.3484L13.6948 2.75016C13.5395 2.95715 13.5815 3.25079 13.7884 3.40603C13.9954 3.56126 14.2891 3.51932 14.4443 3.31233L15.4956 1.91057C15.6509 1.70358 15.6089 1.40994 15.4019 1.2547Z",
    fill: beamColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0668318 4.30238C0.199948 4.08052 0.487714 4.00858 0.709574 4.1417L2.46178 5.19302C2.68364 5.32614 2.75558 5.6139 2.62246 5.83576C2.48935 6.05762 2.20158 6.12956 1.97972 5.99645L0.227517 4.94513C0.0056569 4.81201 -0.0662845 4.52424 0.0668318 4.30238Z",
    fill: beamColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3233 4.30238C19.1902 4.08052 18.9024 4.00858 18.6806 4.1417L16.9284 5.19302C16.7065 5.32614 16.6346 5.6139 16.7677 5.83576C16.9008 6.05762 17.1886 6.12956 17.4104 5.99645L19.1626 4.94513C19.3845 4.81201 19.4564 4.52424 19.3233 4.30238Z",
    fill: beamColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63596 0C9.89469 0 10.1044 0.209743 10.1044 0.468475V2.57112C10.1044 2.82985 9.89469 3.03959 9.63596 3.03959C9.37722 3.03959 9.16748 2.82985 9.16748 2.57112V0.468475C9.16748 0.209743 9.37722 0 9.63596 0Z",
    fill: beamColor,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.91406 18.9247H13.3561V20.5981C13.3561 21.3345 12.7591 21.9314 12.0227 21.9314H7.24741C6.51103 21.9314 5.91406 21.3345 5.91406 20.5981V18.9247ZM6.85101 19.8616V20.5981C6.85101 20.817 7.02849 20.9945 7.24741 20.9945H12.0227C12.2416 20.9945 12.4191 20.817 12.4191 20.5981V19.8616H6.85101Z",
    fill: "inherit",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.80078 20.9933H12.4687V22.6666C12.4687 23.403 11.8717 24 11.1353 24H8.13413C7.39774 24 6.80078 23.403 6.80078 22.6666V20.9933ZM7.73773 21.9302V22.6666C7.73773 22.8856 7.91521 23.063 8.13413 23.063H11.1353C11.3543 23.063 11.5317 22.8856 11.5317 22.6666V21.9302H7.73773Z",
    fill: "inherit",
    stroke: "none"
  }));
};